<script setup lang="ts">
import type { PropType } from 'vue';

export type BlockThreeColItem = {
    icon: string;
    description: string;
};

// PROPS
defineProps({
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    items: { type: Array as PropType<BlockThreeColItem[]>, default: () => [] },
});
</script>

<template>
    <BaseWidthContainer class="flex flex-col gap-y-6 md:gap-y-9 xl:gap-y-12">
        <h4 v-if="!!title" class="text-highlighted text-center text-4xl font-semibold md:text-5xl">
            {{ title }}
        </h4>
        <p v-if="!!description" class="text-muted text-center font-medium md:text-xl">
            {{ description }}
        </p>
        <div class="flex flex-col items-stretch gap-y-6 md:grid md:grid-cols-3 md:gap-8">
            <template v-for="(item, _index) in items" :key="_index">
                <slot name="item" :item="item">
                    <BlockItem v-bind="item" />
                </slot>
            </template>
        </div>
    </BaseWidthContainer>
</template>
